import React, { useState } from "react";

const PowerCard = (props) => {

    const drawGridX = props.drawGridX;
    const drawGridY = props.drawGridY;

    let cardStyle = {
        gridArea: drawGridY + "/" + drawGridX
    };

    function classNames(classes) {
        return Object.entries(classes)
            .filter(([key, value]) => value)
            .map(([key, value]) => key)
            .join(' ');
    }

    const cardClasses = {
        'App--quade-power-card': true,
        'Power-card-selected': props.isSelected && !props.isLearned,
        'Power-card-selected-black': props.isSelected && props.isLearned,
        'Power-card-unavailable': !props.item.isGRF && !props.isAvailable && !props.isLearned,
        'Power-card-available': !props.item.isGRF && props.isAvailable && !props.isSkipped,
        'Power-card-learned': !props.item.isGRF && props.isLearned,
        'Power-card-skipped': !props.item.isGRF && props.isSkipped,
        'Power-card-grf': props.item.isGRF && !props.isLearned && !props.isAvailable,
        'Power-card-grf-available': props.item.isGRF && props.isAvailable,
        'Power-card-grf-learned': props.item.isGRF && props.isLearned
    };

    const cardClassNames = classNames(cardClasses);

    const cardNameClasses = {
        'Power-card-name-text': true,
        'Power-card-name-learned': !props.item.isGRF && props.isLearned
    };

    const cardNameClassNames = classNames(cardNameClasses);

    // processing

    function FindRequiredDashedLinkID() {
        const powerLinks = props.powerLinks;
        let hasSolidLink = false;
        let hasDashedLink = false;
        let dashedLinkID = null;
        for (let powerLinkID in powerLinks) {
            let powerLink = powerLinks[powerLinkID];
            const powerID1 = powerLink.powerIDs[0];
            const powerID2 = powerLink.powerIDs[1];
            const pp1 = props.powers[powerID1];
            const pp2 = props.powers[powerID2];
            // the link goes to a power we already have
            if ((pp1 !== undefined && pp1 !== 0 && powerID1 !== props.item.id)
                || (pp2 !== undefined && pp2 !== 0 && powerID2 !== props.item.id)) {
                if (!hasSolidLink) {
                    hasSolidLink = !powerLink.isDotted;
                }
                if (!hasDashedLink) {
                    hasDashedLink = powerLink.isDotted;
                }
                if (powerLink.isDotted) {
                    dashedLinkID = powerLink.id;
                }
            }
        }

        if (!hasSolidLink && hasDashedLink) {
            return dashedLinkID;
        }
        return null;
    }

    // IDs of links that connect to this power-- not necessarily required
    function FindSolidLinkIDs() {
        let linkIDs = [];
        const powerLinks = props.powerLinks;
        for (let powerLinkID in powerLinks) {
            let powerLink = powerLinks[powerLinkID];
            const powerID1 = powerLink.powerIDs[0];
            const powerID2 = powerLink.powerIDs[1];
            const pp1 = props.powers[powerID1];
            const pp2 = props.powers[powerID2];
            // the link goes to a power we have
            if ((pp1 !== undefined && pp1 !== 0 && powerID1 !== props.item.id)
                || (pp2 !== undefined && pp2 !== 0 && powerID2 !== props.item.id)) {
                if (!powerLink.isDotted) {
                    linkIDs.push(powerLink.id);
                }
            }
        }
        return linkIDs;
    }

    function SetPowerPoints(points, linkPoints, shouldUpdateLink=true) {
       
        if (shouldUpdateLink) {
            // update dashed links
            const dashedLinkID = FindRequiredDashedLinkID();
            if (dashedLinkID !== null) {
                let copyLinks = structuredClone(props.dashedLinks);
                copyLinks[dashedLinkID] = linkPoints;
                props.setDashedLinks(copyLinks);
            }
            // update solid links
            const solidLinkIDs = FindSolidLinkIDs();
            for (let linkIndex in solidLinkIDs) {
                const linkID = solidLinkIDs[linkIndex];
                let copyLinks = structuredClone(props.solidLinks);
                copyLinks[linkID] = linkPoints;
                props.setSolidLinks(copyLinks);
            }
        }
        const powerID = props.item.id;
        // this map represents how many points the player has invested in powers, keyed by ID.
        // having a GRF is shown as 1, and not having one is shown as 0.
        // skipped powers are shown as -1
        let copyPowers = structuredClone(props.powers);
        copyPowers[powerID] = points;
        props.setPowers(copyPowers);
    }

    function BuyPower() {
        const powerID = props.item.id;
        if (powerID in props.powers && props.powers[powerID] > 0) {
            // skipping is allowed
            throw new DOMException("Not allowed to buy a power we already have!");
        }        
        SetPowerPoints(1, 1);
    }

    function UnlearnPower() {
        const powerID = props.item.id;
        if (!(powerID in props.powers || props.powers[powerID] === 0)) {
            throw new DOMException("Not allowed to unlearn a power we don't have!");
        }
        SetPowerPoints(0, 0);
    }

    function SkipPower(e) {
        e.preventDefault();
        const powerID = props.item.id;
        if (powerID in props.powers && props.powers[powerID] < 0) {
            throw new DOMException("Not allowed to skip a power we have already skipped!");
        }
        SetPowerPoints(-1, 1, props.currentPoints === 0);
    }

    // logic

    function ShouldAllowRemoving() {

        if (!props.isEditable) {
            return false;
        }
        return props.canRemove;
    }

    function ShouldDisplayDecrementButton() {
        if (!props.isEditable) {
            return false;
        }
        if (ShouldAllowRemoving()) {
            return true;
        }
        return AllowDecrementing();
    }

    function ShouldDisplayIncrementButton() {
        if (!props.isEditable) {
            return false;
        }
        if (props.isAvailable) {
            return true;
        }
        if (AllowIncrementing()) {
            return true;
        }
        return false;
    }

    function CurrentPoints() {
        return props.currentPoints;
    }

    function AllowDecrementing() {
        if (!props.isEditable) {
            return false;
        }
        if (!props.canChangePoints) {
            return false;
        }
        if (props.currentPoints === 1) {
            return ShouldAllowRemoving();
        }
        return true;
    }

    function AllowIncrementing() {
        if (!props.isEditable) {
            return false;
        }
        if (!props.canChangePoints) {
            return false;
        }
        return props.canIncrement;
    }

    // interactions

    function OnClickCard() {
        if (props.isEditable) {
            return;
        }
        props.setSelectedPowerID(parseInt(props.item.id));
    }

    function LearnPower(e) {
        if (props.isAvailable) {
            BuyPower();
        }
    }

    function DecrementPoints() {
        if (props.currentPoints === 1) {
            if (ShouldAllowRemoving()) {
                UnlearnPower();
            }
        } else {
            SetPowerPoints(props.currentPoints - 1, 1, false);
        }
    }

    function IncrementPoints() {
        if (AllowIncrementing()) {
            SetPowerPoints(props.currentPoints + 1, 1, false);
        }
    }

    function ClickIncrement() {
        if (AllowIncrementing()) {
            IncrementPoints();
        } else if (props.isAvailable) {
            LearnPower(null);
        }
    }

    function ClickDecrement() {
        if (AllowDecrementing()) {
            DecrementPoints();
        } else if (ShouldAllowRemoving()) {
            UnlearnPower();
        }
    }

    function IncrementButtonText() {
        if (props.isAvailable) {
            return "+";
        }
        if (props.isLearned && AllowIncrementing()) {
            return "" + CurrentPoints();
        }
    }

    // rendering 

    return (
        <div
            className={cardClassNames}
            style={cardStyle}
            onClick={OnClickCard}
        >
            <div style={{
                display: "flex",
                flexDirection:"row"
            }}>
                {props.item.isInvestigative && (
                    <img alt="mag"
                        src="./mag-icon.png"
                        width="25px"
                        height="25px"
                        
                        style={{
                            display:"block",
                            marginLeft: "-32px",
                            marginRight: "8px",
                            alignSelf: "center"
                        }}
                    >
                    </img>
                )}
            <div className={cardNameClassNames} >
                {props.item.name}
                </div>
            </div>
            <div style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                width: "100%",
                marginTop: "auto",
                position: "relative",
                bottom: "-12px"
            }}>
                <div style={{ flex: "1" }}>
                {ShouldDisplayDecrementButton() && (
                    <button
                            type="button"
                            className="Power-card-corner-button"
                            onClick={ClickDecrement}
                            style={{ marginLeft:"-10px" }}
                        >
                        -
                    </button>
                    )}
                </div>
                <div style={{ flex: "1" }}>
                    {props.isEditable && props.canSkip && (
                        <button type="button"
                            onClick={SkipPower}
                            className="Power-card-corner-button"
                            style={{
                                fontSize: "10px",
                                width: "32px",
                                marginTop: "-5px",
                                paddingLeft:"5px"
                            }}
                        >
                            SKIP
                        </button>
                    )}
                </div>
                <div style={{ flex: "1" }}>
                {ShouldDisplayIncrementButton() && (
                    <button
                            type="button"
                            className="Power-card-corner-button"
                            onClick={ClickIncrement}
                            style={{ marginRight: "-10px" }}
                        >
                            {IncrementButtonText()}
                    </button>
                    )}
                </div>
            </div>
            
        </div>
    );
};

export default PowerCard;